import { z } from "zod";

const SystemStatusSchema = z.object({
  indicator: z.enum(["none", "minor", "major", "critical"]),
  description: z.string(),
});

const SystemStatusPageSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.url(),
  time_zone: z.string(),
  updated_at: z.iso.datetime({ offset: true }),
});

const SystemStatusResponseSchema = z.object({
  page: SystemStatusPageSchema,
  status: SystemStatusSchema,
});

type SystemStatus = z.infer<typeof SystemStatusSchema>;
type SystemStatusResponse = z.infer<typeof SystemStatusResponseSchema>;

export { SystemStatusSchema, SystemStatusResponseSchema };
export type { SystemStatus, SystemStatusResponse };
